const REQUEST_CLIENTS_TOTAL = 'platfi-ui-app/MONITOR/REQUEST_CLIENTS_TOTAL';
const REQUEST_CLIENTS_TOTAL_SUCCESS = 'platfi-ui-app/MONITOR/REQUEST_CLIENTS_TOTAL_SUCCESS';
const REQUEST_CLIENTS_TOTAL_FAILURE = 'platfi-ui-app/MONITOR/REQUEST_CLIENTS_TOTAL_FAILURE';
const CLIENT_ENCODED_DATA_REQUEST = 'platfi-up-app/MONITOR/CLIENT_ENCODED_DATA_REQUEST';
const CLIENT_ENCODED_DATA_SUCCESS = 'platfi-up-app/MONITOR/CLIENT_ENCODED_DATA_SUCCESS';
const CLIENT_ENCODED_DATA_FAILURE = 'platfi-up-app/MONITOR/CLIENT_ENCODED_DATA_FAILURE';

export {
  REQUEST_CLIENTS_TOTAL,
  REQUEST_CLIENTS_TOTAL_SUCCESS,
  REQUEST_CLIENTS_TOTAL_FAILURE,
  CLIENT_ENCODED_DATA_REQUEST,
  CLIENT_ENCODED_DATA_SUCCESS,
  CLIENT_ENCODED_DATA_FAILURE,
};
